import styled from 'styled-components';

import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const ImgStyled = styled.img`
  height: 225px;
  object-fit: cover;
  width: 100%;
`;

export const ImageWrapper = styled(Flex)`
  height: 226px;
  justify-content: center;
  align-items: center;
`;
